import { useAsync } from 'react-use';

import { useApi } from '@backstage/core-plugin-api';

import { tomtomLabApiRef } from '../api';
import { EventConfigMetadata } from '../types';

export const useEventConfig = (eventId: number | undefined) => {
  const tomtomLabApi = useApi(tomtomLabApiRef);

  const {
    value: eventConfigs,
    loading,
    error,
  } = useAsync(async () => {
    if (!eventId) return undefined;
    return tomtomLabApi.listEventConfigValues(eventId);
  }, [eventId]);

  const updateEventConfig = async (
    configKey: string,
    metadata: EventConfigMetadata,
  ): Promise<void> => {
    if (!eventId) return Promise.reject('No eventId provided');
    return await tomtomLabApi.updateEventConfigValue(
      eventId,
      configKey,
      metadata,
    );
  };

  return {
    eventConfigs,
    loading,
    error,
    updateEventConfig,
  };
};
